import { withSvgIcon } from './withSvgIcon';

export const Wallet = withSvgIcon(
  <>
    <path
      d="M4 6V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V10C20 8.89543 19.1046 8 18 8H6C4.89543 8 4 7.10457 4 6V6ZM4 6V6C4 4.89543 4.89543 4 6 4H18"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <circle cx="16.5" cy="13.5" r="1.5" fill="currentColor" />
  </>,
  { viewBox: '0 0 24 24' },
);
